import Highcharts from 'highcharts'

var chartHelper = {
    ChartType: {
        Monthly: 0,
        Daily: 1,
        Hourly: 2,
        SevenDays: 3 // used for Recent usage/Dollar chart on Customer Portal
    },
    ChartConsumptionType: {
        None: 0,
        Consumption: 1,
        Dollar: 2
    },
    ResponsivePointWidth: null,
    getChartOptions: function(chartTitle, chartType, onPointClick, consumptionData, highTempData, lowTempData, xAxisMin, xAxisMax, cursorInfo, yAxisPrimaryTitle, yAxisName, chartColor,
        dollarPrefix, consumptionSuffix, moreDetails, highTempTitle, lowTempTitle, displayTemperatureSeries) {
            var xaxisDateFormat = '%H:%M';
            var xAxisMinValue = xAxisMin;
            var xAxisMaxValue = xAxisMax;

            var timeInterval = 3600 * 1000; //down to hours

            if (chartType === this.ChartType.Daily) {
                timeInterval *= 24; //24 hours
                xaxisDateFormat = '%m/%e/%Y';
                this.ResponsivePointWidth = null;
            }

            if (chartType === this.ChartType.Monthly) {
                timeInterval = 3600 * 24 * 30 * 1000;
                xaxisDateFormat = '%b %Y';
                this.ResponsivePointWidth = null;
            }

            if (chartType === this.ChartType.Hourly)
            {
                xAxisMinValue = new Date(xAxisMin);
                xAxisMaxValue = new Date(xAxisMax);
                this.ResponsivePointWidth = 15;
            }

            var options = {

                chartConsumptionType: chartType,

                chart: {
                    type: 'column',
                    zoomType: 'x'
                },

                title: {
                    text: chartTitle
                },

                legend: {
                    enabled: true
                },

                credits: {
                    enabled: false
                },

                xAxis: {
                    events: {
                        //afterSetExtremes: afterSetExtremes
                    },
                    type: 'datetime',
                    tickInterval: timeInterval,
                    min: xAxisMinValue,
                    max: xAxisMaxValue,
                    labels: {
                        formatter: function () {
                            return Highcharts.dateFormat(xaxisDateFormat, this.value)
                        }
                    }
                },

                yAxis: [{ // Primary yAxis
                    labels: {
                        format: '{value} °F',
                        style: {
                            color: "black"
                        }
                    },
                    title: {
                        text: yAxisPrimaryTitle,
                        style: {
                            color: "black"
                        }
                    },
                    opposite: true

                }, { // Secondary yAxis
                    gridLineWidth: 0,
                    title: {
                        text: yAxisName,
                        style: {
                            color: "black"
                        }
                    },
                    labels: {
                        format: '{value}',
                        style: {
                            color: "black"
                        }
                    }

                }],

                series: [{
                    name: yAxisName,
                    type: 'column',
                    yAxis: 1,
                    data: consumptionData,
                    color: chartColor,
                    tooltip: {
                        valuePrefix: dollarPrefix,
                        valueSuffix: moreDetails
                    }
                },
                {
                    name: highTempTitle,
                    type: 'line',
                    data: highTempData,
                    color: 'red',
                    tooltip: {
                        valueSuffix: ' °F'
                    },
                    showInLegend: displayTemperatureSeries
                },
                {
                    name: lowTempTitle,
                    type: 'line',
                    data: lowTempData,
                    color: 'blue',
                    tooltip: {
                        valueSuffix: ' °F'
                    },
                    showInLegend: displayTemperatureSeries
                }],

                plotOptions: {
                    series: {
                        cursor: cursorInfo,
                        point: {
                            events: {
                                click: onPointClick
                            }
                        },
                        marker: {
                            lineWidth: 1
                        }
                    }
                },

                navigation: {
                    buttonOptions: {
                        enabled: false
                    }
                },

                responsive: {
                    rules: [
                    {
                        condition: {
                            maxWidth: 768
                        },
                        chartOptions: {
                            yAxis: [{}, { // Secondary yAxis
                                stackLabels: {
                                    enabled: true
                                }
                            }],

                            plotOptions: {
                                series: {
                                    pointWidth: this.ResponsivePointWidth
                                }
                            }
                        }
                    }]
                }
            }
            return options
    },
    getDollarChartOptions: function(chartTitle, chartType, onPointClick, categoriesData, stackedSeriesData, pointClickText, yAxisTitle, yPrimaryAxisTitle) {
        var isEnabled = true;
        var stackLabelsEnabled = true;
        var xaxisDateFormat = '';

        if (chartType === this.ChartType.Hourly) {
            this.ResponsivePointWidth = 15;
            xaxisDateFormat = '%H:%M';
        } else {
            this.ResponsivePointWidth = null;
        }

        if (chartType === this.ChartType.Daily) {
            stackLabelsEnabled = false;
        }

        if (chartType === this.ChartType.SevenDays) {
            isEnabled = false;
        }

        var options = {

            chartConsumptionType: chartType,

            chart: {
                type: 'column',
                zoomType: 'xy'
            },

            title: {
                text: chartTitle
            },

            xAxis: {
                categories: categoriesData,
                tickInterval: 1.5,
                type: 'datetime',
                min: null,
                max: null,
                labels: {
                    formatter: function () {
                        if (xaxisDateFormat !== '') {
                            return Highcharts.dateFormat(xaxisDateFormat, new Date(this.value))
                        } else {
                            return this.value;
                        }
                    }
                }
            },

            yAxis: [{ // Primary yAxis - Temperature
                labels: {
                    formatter: function () {
                        return this.value + ' °F';
                    }
                },
                title: {
                    text: yPrimaryAxisTitle
                },
                opposite: true

            }, { // Secondary yAxis - Dollar
                gridLineWidth: 0,
                title: {
                    text: yAxisTitle
                },
                labels: {
                    formatter: function () {
                        if (this.value !== null) {
                            return '$' + this.value.toFixed(2);
                        }                        
                    }
                },
                stackLabels: {
                    enabled: stackLabelsEnabled,
                    style: {
                        fontWeight: 'bold',
                        color: 'gray'
                    },
                    formatter: function () {
                        if (this.total !== null) {
                            return '$' + this.total.toFixed(2);
                        }                        
                    }
                }
            }],

            legend: {
                enabled: true
            },

            credits: {
                enabled: false
            },

            plotOptions: {
                column: {
                    stacking: 'normal'
                },
                series: {
                    point: {
                        events: {
                            click: onPointClick
                        }
                    },
                    marker: {
                        lineWidth: 1
                    },
                    groupPadding: 0.2,
                    pointWidth: 15,
                    maxPointWidth: 20
                }
            },

            navigation: {
                buttonOptions: {
                    enabled: false
                }
            },

            exporting: {
                enabled: isEnabled
            },

            series: stackedSeriesData,

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 768
                    },
                    chartOptions: {
                        yAxis: [{}, { // Secondary yAxis
                            stackLabels: {
                                enabled: false
                            }
                        }],

                        plotOptions: {
                            series: {
                                pointWidth: this.ResponsivePointWidth
                            }
                        }
                    }
                }]
            }
        }
        return options
    },
    formatDateArray(dateData) {
        var formattedDateArray = []
        for (var i = 0; i < dateData.length; i++) {
            var tmpDate = new Date(dateData[i].replace(/-/g, '\/').replace(/T.+/, ''))
            formattedDateArray.push(this.getMonthName(tmpDate.getMonth()) + " " + tmpDate.getFullYear())
        }
        return formattedDateArray;
    },
    formatToDisplayDates(dateData) {
        var formattedArrayWithDates = []
        for (var i = 0; i < dateData.length; i++) {
            var tmpDate = new Date(dateData[i].replace(/-/g, '\/').replace(/T.+/, ''))
            formattedArrayWithDates.push((tmpDate.getMonth() + 1) + '/' + (tmpDate.getDate()) + '/' + (tmpDate.getFullYear())) // Date: 05/04/2017
        }
        return formattedArrayWithDates
    },
    formatToDisplayHours(dateData) {
        var formattedArrayWithHours = []
        for (var i = 0; i < dateData.length; i++) {
            var tmpDate = new Date(dateData[i])
            formattedArrayWithHours.push((tmpDate.getMonth() + 1) + '/' + (tmpDate.getDate()) + '/' + (tmpDate.getFullYear()) + ' ' + ('0' + tmpDate.getHours()).substr(-2) + ':' + ('0' + tmpDate.getMinutes()).substr(-2)) // Format: 09/20/2018 01:00
        }
        return formattedArrayWithHours
    },
    sortCategoriesData(a, b) {
        return new Date(a).getTime() - new Date(b).getTime()
    },
    getMonthName(monthNumber) {
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"]
        return monthNames[monthNumber]
    },
    getMonth(monthStr, year) {
        return new Date(monthStr + " -1-" + year).getMonth() + 1
    },
    addDays(date, count) {
        if (date && count) {
            date = new Date(+date)
            var d = date.getUTCDate()
            date.setUTCDate(d + count)
        }
        return date
    },
    addMonths(date, count) {
        if (date && count) {
            var m, d = (date = new Date(+date)).getUTCDate()
            date.setUTCMonth(date.getUTCMonth() + count, 1)
            m = date.getUTCMonth()
            date.setUTCDate(d)

            if (date.getUTCMonth() != m) {
                date.setUTCDate(0)
            }
        }
        return date
    },
    addDaysFromMillis(time, count) {
        return addDays(new Date(time).getTime(), count).getTime()
    }
}

export default chartHelper